import React, { useContext, useEffect } from 'react';
import { LeReacteurContext } from '../../Layout';
import { Paragraph } from 'src/components/Typography';

const FinalBlock = () => {
  const { dtlFormValidation } = useContext(LeReacteurContext);
  useEffect(() => {
    if (window) {
      window.scrollTo({
        top: 90,
        left: 0,
        behavior: 'smooth',
      });
    } else {
      return null;
    }
  });
  useEffect(() => {
    dtlFormValidation('event');
  }, []);

  return (
    <>
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: 330,
        }}
      >
        <Paragraph css={{ textAlign: 'center' }}>
          Votre inscription a bien été prise en compte.
          <br />
          Veuillez consulter vos emails pour le détail de l'événement.
        </Paragraph>
      </div>
    </>
  );
};

export default FinalBlock;
